module.exports = __webpack_public_path__ + "static/media/order_icon19.f97de46c.png";